export interface DaysOpenPill {
  text: string;
  color: string;
}

const DAYS_OPEN_WARNING_THRESHOLD = 30;
const DAYS_OPEN_CRITICAL_THRESHOLD = 60;

export const getDaysOpenPill = (daysOpen: number): DaysOpenPill => {
  const label = `Open for ${daysOpen} ${daysOpen === 1 ? 'day' : 'days'}`;

  if (daysOpen <= DAYS_OPEN_WARNING_THRESHOLD) {
    return { text: label, color: 'var(--color-status-positive)' };
  }

  if (daysOpen <= DAYS_OPEN_CRITICAL_THRESHOLD) {
    return { text: label, color: 'var(--color-status-negative)' };
  }

  return { text: label, color: 'var(--color-status-critical)' };
};
